/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Equipment,
    EquipmentFromJSON,
    EquipmentToJSON,
} from '../models/Equipment';
import {
    type InfrastructureSitesListEmissionStatsParameter,
    InfrastructureSitesListEmissionStatsParameterFromJSON,
    InfrastructureSitesListEmissionStatsParameterToJSON,
} from '../models/InfrastructureSitesListEmissionStatsParameter';
import {
    type InfrastructureStats,
    InfrastructureStatsFromJSON,
    InfrastructureStatsToJSON,
} from '../models/InfrastructureStats';
import {
    type PaginatedEquipmentList,
    PaginatedEquipmentListFromJSON,
    PaginatedEquipmentListToJSON,
} from '../models/PaginatedEquipmentList';
import {
    type PaginatedPipelineList,
    PaginatedPipelineListFromJSON,
    PaginatedPipelineListToJSON,
} from '../models/PaginatedPipelineList';
import {
    type PaginatedPipelineSegmentList,
    PaginatedPipelineSegmentListFromJSON,
    PaginatedPipelineSegmentListToJSON,
} from '../models/PaginatedPipelineSegmentList';
import {
    type PaginatedSiteList,
    PaginatedSiteListFromJSON,
    PaginatedSiteListToJSON,
} from '../models/PaginatedSiteList';
import {
    type Pipeline,
    PipelineFromJSON,
    PipelineToJSON,
} from '../models/Pipeline';
import {
    type PipelineSegment,
    PipelineSegmentFromJSON,
    PipelineSegmentToJSON,
} from '../models/PipelineSegment';
import {
    type Site,
    SiteFromJSON,
    SiteToJSON,
} from '../models/Site';

export interface InfrastructureEquipmentListRequest {
    equipmentType?: string;
    infraType?: Array<InfrastructureEquipmentListInfraTypeEnum>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    nearEmission?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
    parent?: string;
    search?: string;
    site?: Array<string>;
    withoutParent?: boolean;
}

export interface InfrastructureEquipmentRetrieveRequest {
    id: string;
}

export interface InfrastructurePipelineListRequest {
    lengthMax?: number | null;
    lengthMin?: number | null;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
    pipelineProduct?: Array<InfrastructurePipelineListPipelineProductEnum>;
    pipelineType?: Array<InfrastructurePipelineListPipelineTypeEnum>;
}

export interface InfrastructurePipelineRetrieveRequest {
    id: string;
}

export interface InfrastructurePipelineSegmentsListRequest {
    nearPoint?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
    pipeline?: string;
}

export interface InfrastructurePipelineSegmentsRetrieveRequest {
    id: string;
}

export interface InfrastructureSitesInfrastructureStatsRetrieveRequest {
    distanceTo?: string;
    emissionStats?: InfrastructureSitesListEmissionStatsParameter;
    hasExternalProvider?: Array<InfrastructureSitesInfrastructureStatsRetrieveHasExternalProviderEnum>;
    ids?: Array<string>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    nearEmission?: string;
    ordering?: string;
    search?: string;
    siteName?: string;
    siteType?: Array<string>;
}

export interface InfrastructureSitesListRequest {
    distanceTo?: string;
    emissionStats?: InfrastructureSitesListEmissionStatsParameter;
    hasExternalProvider?: Array<InfrastructureSitesListHasExternalProviderEnum>;
    ids?: Array<string>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    nearEmission?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    siteName?: string;
    siteType?: Array<string>;
}

export interface InfrastructureSitesRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class InfrastructureApi extends runtime.BaseAPI {

    /**
     * Creates request options for infrastructureEquipmentList without sending the request
     */
    async infrastructureEquipmentListRequestOpts(requestParameters: InfrastructureEquipmentListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['equipmentType'] != null) {
            queryParameters['equipment_type'] = requestParameters['equipmentType'];
        }

        if (requestParameters['infraType'] != null) {
            queryParameters['infra_type'] = requestParameters['infraType'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['nearEmission'] != null) {
            queryParameters['near_emission'] = requestParameters['nearEmission'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['parent'] != null) {
            queryParameters['parent'] = requestParameters['parent'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['withoutParent'] != null) {
            queryParameters['without_parent'] = requestParameters['withoutParent'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/infrastructure/equipment/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve equipment information
     */
    async infrastructureEquipmentListRaw(requestParameters: InfrastructureEquipmentListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEquipmentList>> {
        const requestOptions = await this.infrastructureEquipmentListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEquipmentListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve equipment information
     */
    async infrastructureEquipmentList(requestParameters: InfrastructureEquipmentListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEquipmentList> {
        const response = await this.infrastructureEquipmentListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for infrastructureEquipmentRetrieve without sending the request
     */
    async infrastructureEquipmentRetrieveRequestOpts(requestParameters: InfrastructureEquipmentRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling infrastructureEquipmentRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/infrastructure/equipment/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve equipment information
     */
    async infrastructureEquipmentRetrieveRaw(requestParameters: InfrastructureEquipmentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Equipment>> {
        const requestOptions = await this.infrastructureEquipmentRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EquipmentFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve equipment information
     */
    async infrastructureEquipmentRetrieve(requestParameters: InfrastructureEquipmentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Equipment> {
        const response = await this.infrastructureEquipmentRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for infrastructurePipelineList without sending the request
     */
    async infrastructurePipelineListRequestOpts(requestParameters: InfrastructurePipelineListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['lengthMax'] != null) {
            queryParameters['length_max'] = requestParameters['lengthMax'];
        }

        if (requestParameters['lengthMin'] != null) {
            queryParameters['length_min'] = requestParameters['lengthMin'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['pipelineProduct'] != null) {
            queryParameters['pipeline_product'] = requestParameters['pipelineProduct'];
        }

        if (requestParameters['pipelineType'] != null) {
            queryParameters['pipeline_type'] = requestParameters['pipelineType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/infrastructure/pipeline/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve pipeline information
     */
    async infrastructurePipelineListRaw(requestParameters: InfrastructurePipelineListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPipelineList>> {
        const requestOptions = await this.infrastructurePipelineListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPipelineListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve pipeline information
     */
    async infrastructurePipelineList(requestParameters: InfrastructurePipelineListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPipelineList> {
        const response = await this.infrastructurePipelineListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for infrastructurePipelineRetrieve without sending the request
     */
    async infrastructurePipelineRetrieveRequestOpts(requestParameters: InfrastructurePipelineRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling infrastructurePipelineRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/infrastructure/pipeline/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve pipeline information
     */
    async infrastructurePipelineRetrieveRaw(requestParameters: InfrastructurePipelineRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Pipeline>> {
        const requestOptions = await this.infrastructurePipelineRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PipelineFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve pipeline information
     */
    async infrastructurePipelineRetrieve(requestParameters: InfrastructurePipelineRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Pipeline> {
        const response = await this.infrastructurePipelineRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for infrastructurePipelineSegmentsList without sending the request
     */
    async infrastructurePipelineSegmentsListRequestOpts(requestParameters: InfrastructurePipelineSegmentsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['nearPoint'] != null) {
            queryParameters['near_point'] = requestParameters['nearPoint'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['pipeline'] != null) {
            queryParameters['pipeline'] = requestParameters['pipeline'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/infrastructure/pipeline-segments/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve pipeline segment information
     */
    async infrastructurePipelineSegmentsListRaw(requestParameters: InfrastructurePipelineSegmentsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPipelineSegmentList>> {
        const requestOptions = await this.infrastructurePipelineSegmentsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPipelineSegmentListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve pipeline segment information
     */
    async infrastructurePipelineSegmentsList(requestParameters: InfrastructurePipelineSegmentsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPipelineSegmentList> {
        const response = await this.infrastructurePipelineSegmentsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for infrastructurePipelineSegmentsRetrieve without sending the request
     */
    async infrastructurePipelineSegmentsRetrieveRequestOpts(requestParameters: InfrastructurePipelineSegmentsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling infrastructurePipelineSegmentsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/infrastructure/pipeline-segments/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve pipeline segment information
     */
    async infrastructurePipelineSegmentsRetrieveRaw(requestParameters: InfrastructurePipelineSegmentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PipelineSegment>> {
        const requestOptions = await this.infrastructurePipelineSegmentsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PipelineSegmentFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve pipeline segment information
     */
    async infrastructurePipelineSegmentsRetrieve(requestParameters: InfrastructurePipelineSegmentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PipelineSegment> {
        const response = await this.infrastructurePipelineSegmentsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for infrastructureSitesInfrastructureStatsRetrieve without sending the request
     */
    async infrastructureSitesInfrastructureStatsRetrieveRequestOpts(requestParameters: InfrastructureSitesInfrastructureStatsRetrieveRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['emissionStats'] != null) {
            queryParameters['emission_stats'] = requestParameters['emissionStats'];
        }

        if (requestParameters['hasExternalProvider'] != null) {
            queryParameters['has_external_provider'] = requestParameters['hasExternalProvider'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['nearEmission'] != null) {
            queryParameters['near_emission'] = requestParameters['nearEmission'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['siteName'] != null) {
            queryParameters['site_name'] = requestParameters['siteName'];
        }

        if (requestParameters['siteType'] != null) {
            queryParameters['site_type'] = requestParameters['siteType']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/infrastructure/sites/infrastructure_stats/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns counts of sites.
     */
    async infrastructureSitesInfrastructureStatsRetrieveRaw(requestParameters: InfrastructureSitesInfrastructureStatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InfrastructureStats>> {
        const requestOptions = await this.infrastructureSitesInfrastructureStatsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfrastructureStatsFromJSON(jsonValue));
    }

    /**
     * Returns counts of sites.
     */
    async infrastructureSitesInfrastructureStatsRetrieve(requestParameters: InfrastructureSitesInfrastructureStatsRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InfrastructureStats> {
        const response = await this.infrastructureSitesInfrastructureStatsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for infrastructureSitesList without sending the request
     */
    async infrastructureSitesListRequestOpts(requestParameters: InfrastructureSitesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['emissionStats'] != null) {
            queryParameters['emission_stats'] = requestParameters['emissionStats'];
        }

        if (requestParameters['hasExternalProvider'] != null) {
            queryParameters['has_external_provider'] = requestParameters['hasExternalProvider'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['nearEmission'] != null) {
            queryParameters['near_emission'] = requestParameters['nearEmission'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['siteName'] != null) {
            queryParameters['site_name'] = requestParameters['siteName'];
        }

        if (requestParameters['siteType'] != null) {
            queryParameters['site_type'] = requestParameters['siteType']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/infrastructure/sites/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve site information
     */
    async infrastructureSitesListRaw(requestParameters: InfrastructureSitesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSiteList>> {
        const requestOptions = await this.infrastructureSitesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSiteListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve site information
     */
    async infrastructureSitesList(requestParameters: InfrastructureSitesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSiteList> {
        const response = await this.infrastructureSitesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for infrastructureSitesRetrieve without sending the request
     */
    async infrastructureSitesRetrieveRequestOpts(requestParameters: InfrastructureSitesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling infrastructureSitesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/infrastructure/sites/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve site information
     */
    async infrastructureSitesRetrieveRaw(requestParameters: InfrastructureSitesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>> {
        const requestOptions = await this.infrastructureSitesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve site information
     */
    async infrastructureSitesRetrieve(requestParameters: InfrastructureSitesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site> {
        const response = await this.infrastructureSitesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const InfrastructureEquipmentListInfraTypeEnum = {
    Equipment: 'EQUIPMENT',
    EquipmentComponent: 'EQUIPMENT_COMPONENT',
    EquipmentGroup: 'EQUIPMENT_GROUP',
    Site: 'SITE'
} as const;
export type InfrastructureEquipmentListInfraTypeEnum = typeof InfrastructureEquipmentListInfraTypeEnum[keyof typeof InfrastructureEquipmentListInfraTypeEnum];
/**
 * @export
 */
export const InfrastructurePipelineListPipelineProductEnum = {
    Condensate: 'CONDENSATE',
    NaturalGas: 'NATURAL_GAS',
    Ngl: 'NGL',
    Oil: 'OIL',
    Other: 'OTHER',
    Water: 'WATER'
} as const;
export type InfrastructurePipelineListPipelineProductEnum = typeof InfrastructurePipelineListPipelineProductEnum[keyof typeof InfrastructurePipelineListPipelineProductEnum];
/**
 * @export
 */
export const InfrastructurePipelineListPipelineTypeEnum = {
    Distribution: 'DISTRIBUTION',
    Gathering: 'GATHERING',
    Other: 'OTHER',
    Transmission: 'TRANSMISSION'
} as const;
export type InfrastructurePipelineListPipelineTypeEnum = typeof InfrastructurePipelineListPipelineTypeEnum[keyof typeof InfrastructurePipelineListPipelineTypeEnum];
/**
 * @export
 */
export const InfrastructureSitesInfrastructureStatsRetrieveHasExternalProviderEnum = {
    Longpath: 'longpath',
    Sensirion: 'sensirion'
} as const;
export type InfrastructureSitesInfrastructureStatsRetrieveHasExternalProviderEnum = typeof InfrastructureSitesInfrastructureStatsRetrieveHasExternalProviderEnum[keyof typeof InfrastructureSitesInfrastructureStatsRetrieveHasExternalProviderEnum];
/**
 * @export
 */
export const InfrastructureSitesListHasExternalProviderEnum = {
    Longpath: 'longpath',
    Sensirion: 'sensirion'
} as const;
export type InfrastructureSitesListHasExternalProviderEnum = typeof InfrastructureSitesListHasExternalProviderEnum[keyof typeof InfrastructureSitesListHasExternalProviderEnum];
